<template>
  <div class="container">
    <div
      v-show="message.state"
      class="alert alert-dismissible border-0 fade show"
      :class="message.type"
      role="alert"
    >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>{{ message.msg }}</strong>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div v-if="metamask" class="card">
          <div class="card-body">
            <h2 class="card-title">Asset Information</h2>
            <!--<h4>{{ currents }}</h4>-->
            <br />
            <!--Name and Category -->
            <form>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Asset Name</label>
                  <input
                    v-model="asset_name"
                    disabled
                    type="text"
                    class="form-control"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label>Category</label>
                  <input
                    v-model="asset_category_selected"
                    disabled
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <!--Country and Cadastral Number -->
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Country</label>
                  <input
                    v-model="asset_country_selected"
                    disabled
                    type="text"
                    class="form-control"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label>Cadastral Number</label>
                  <input
                    v-model="asset_cadastral_number"
                    disabled
                    type="text"
                    class="form-control"
                  />
                  <!--<div class="invalid-feedback">
            Sorry, that username's taken. Try another?
          </div>-->
                </div>
              </div>
              <!--City and Trade representative -->
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>City</label>
                  <input
                    v-model="asset_city"
                    disabled
                    type="text"
                    class="form-control"
                  />
                </div>

                <div class="form-group col-md-6">
                  <label>Trade Representative</label>
                  <input
                    v-model="asset_trade_representative"
                    disabled
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <!-- Address and representative email-->
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Address</label>
                  <textarea
                    v-model="asset_address"
                    disabled
                    class="form-control"
                    rows="3"
                    placeholder="Text Here..."
                  ></textarea>
                </div>
                <div class="form-group col-md-6">
                  <label>Trade Representative's E-mail</label>
                  <input
                    v-model="asset_trade_rep_email"
                    disabled
                    type="email"
                    class="form-control"
                  />
                </div>
              </div>

              <br />
              <h3>Asset documents</h3>
              <hr />
              <!--Row 1 documents -->
              <div class="form-row ml-5">
                <div
                  class="form-group col-md-2 col-sm-3"
                  style="margin-bottom: 60px;"
                >
                  <h5 class="text-center" for="inputProjectDocument">
                    Project
                  </h5>
                  <div class="custom-file text-center img-fluid">
                    <input
                      id="inputProjectDocument"
                      disabled
                      type="file"
                      class="custom-file-input"
                      style="display: none;"
                      @change="list_files.push($event.target.files[0])"
                      @click="change_logo(1)"
                    />
                    <label
                      class="btn btn-outline-primary btn-rounded text-center"
                      for="inputProjectDocument"
                    >
                      <img
                        id="inputProjectDocument"
                        class="img-fluid icon_loaded"
                        src="../../../public/icons/check.png"
                        alt="Upload project document icon"
                      />
                    </label>
                  </div>
                </div>
                <div
                  class="form-group col-md-2 col-sm-3"
                  style="margin-bottom: 60px;"
                >
                  <h5 class="text-center" for="inputTransmitterDocument">
                    Transmitter
                  </h5>
                  <div class="custom-file text-center">
                    <input
                      id="inputTransmitterDocument"
                      disabled
                      type="file"
                      class="custom-file-input"
                      style="display: none;"
                      @change="list_files.push($event.target.files[0])"
                      @click="change_logo(2)"
                    />
                    <label
                      class="btn btn-outline-primary btn-rounded text-center"
                      for="inputTransmitterDocument"
                    >
                      <img
                        id="inputTransmitterDocument"
                        class="img-fluid icon_loaded"
                        src="../../../public/icons/check.png"
                        alt="Upload transmitter document icon"
                      />
                    </label>
                  </div>
                </div>
                <div
                  class="form-group col-md-2 col-sm-3"
                  style="margin-bottom: 60px;"
                >
                  <h5 class="text-center" for="inputLegaInformationDocument">
                    Legal information
                  </h5>
                  <div class="custom-file text-center">
                    <label
                      class="btn btn-outline-primary btn-rounded text-center"
                      for="inputLegaInformationDocument"
                    >
                      <img
                        id="inputLegaInformationDocument"
                        class="img-fluid icon_loaded"
                        src="../../../public/icons/check.png"
                        alt="Upload legal information document icon"
                      />
                    </label>
                  </div>
                </div>
                <div
                  class="form-group col-md-2 col-sm-3"
                  style="margin-bottom: 60px;"
                >
                  <h6 class="text-center" for="inputCommercialDossietDocument">
                    Commercial Dossier
                  </h6>
                  <div class="custom-file text-center">
                    <label
                      class="btn btn-outline-primary btn-rounded text-center"
                      for="inputCommercialDossietDocument"
                    >
                      <img
                        id="inputCommercialDossietDocument"
                        class="img-fluid icon_loaded"
                        src="../../../public/icons/check.png"
                        alt="Upload commercial dossier document icon"
                      />
                    </label>
                  </div>
                </div>
                <div
                  class="form-group col-md-2 col-sm-3"
                  style="margin-bottom: 60px;"
                >
                  <h5 class="text-center" for="inputCadastralDocument">
                    Cadastral
                  </h5>
                  <div class="custom-file text-center">
                    <label
                      class="btn btn-outline-primary btn-rounded text-center"
                      for="inputCadastralDocument"
                    >
                      <img
                        id="inputCadastralDocument"
                        class="img-fluid icon_loaded"
                        src="../../../public/icons/check.png"
                        alt="Upload cadastral document icon"
                      />
                    </label>
                  </div>
                </div>
              </div>

              <br />
              <br />
              <br />
              <!-- Switch  -->
              <div v-show="false" class="form-row">
                <div class="form-group col-md-6">
                  <label>Do you want upload more documents?</label>
                  <div class="custom-control custom-switch">
                    <input
                      id="customSwitch1"
                      v-model="flag_extraDocs"
                      type="checkbox"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" for="customSwitch1">
                      No / Yes
                    </label>
                  </div>
                </div>
              </div>
              <hr />
            </form>
          </div>
        </div>
        <div v-else class="card metamask_card text-center">
          <div class="card-body">
            <img
              class="alert_icon"
              src="../../../public/icons/alert-triangle_3.svg"
              alt="alert_icon"
            />
            <h2 class="card-title text-danger">Metamask is not installed!</h2>
            <p>
              Please press the button below to download it.
            </p>
            <div>
              <button
                type="button"
                class="btn btn-outline-primary btn-rounded download_btn"
                @click="downloadMetamask"
              >
                Download
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import './styles/asset_styles.css'; /* switch Button styles*/

#upload_document_icon {
  width: 80px;
  padding: 10px;
}

.icon {
  width: 80px;
  padding: 10px;
}

.icon_loaded {
  width: 70px;
  height: 70px;
  padding: 10px;
}

.download_btn {
  padding: 1rem 5rem;
}

.alert_icon {
  height: 7rem;
  width: 7rem;
  margin-bottom: 1rem;
}

.metamask_card {
  height: 22rem;
}
</style>

<script>
import * as move_tabs from './js/movetabs.js';
import MetaMaskOnboarding from '@metamask/onboarding';

export default {
  name: 'AssetInformation',
  components: {},
  data() {
    return {
      message: {
        state: false,
        msg: '',
        type: '',
      },
      checked: false,
      userId: '',
      assetId: '',
      asset_name: '',
      asset_category_selected: '',
      asset_country_selected: '',
      asset_cadastral_number: '',
      asset_city: '',
      asset_trade_representative: '',
      asset_address: '',
      asset_trade_rep_email: '',
      asset_date_start: '',
      asset_date_end: '',
      asset_stage_number: 0,
      country_list: [],
      asset_categories: [],
      array_dates: [],
      list_files: [],
      files_uploaded: false,
      flag_extraDocs: false,
      list_extraDocs: [],
      flag_show: false,
      email: '',
      metamask: false,
      project: '',
      transmitter: '',
      legal: '',
      dossier: '',
      cadastral: '',
      others: '',
    };
  },
  created() {
    const ethereum = window.ethereum;

    if (typeof ethereum !== 'undefined') {
      this.metamask = true;
    }

    this.loadJSONCountries();
    this.userId = JSON.parse(localStorage.getItem('user')).userId;
    this.email = JSON.parse(localStorage.getItem('user')).email;
    this.assetId = this.$store.state.assetId;

    this.complete_information();
  },
  methods: {
    imprimir(algo) {
      console.log(algo);
    },
    complete_information() {
      this.$http
        .get(`/asset/Info/Data?assetId=${this.assetId}`)
        .then(({ data }) => {
          console.log(data.assetInfo);

          this.userId = data.assetInfo.userId;
          this.asset_name = data.assetInfo.assetName;
          this.asset_country_selected = data.assetInfo.country;
          this.asset_cadastral_number = data.assetInfo.cadastralNumber;
          this.asset_city = data.assetInfo.city;
          this.asset_category_selected = data.assetInfo.category;
          this.asset_trade_representative = data.assetInfo.tradeRepresentative;
          this.asset_trade_rep_email = data.assetInfo.tradeRepresentativeEmail;
          this.asset_address = data.assetInfo.address;
          this.cadastral = data.assetInfo.cadastralDocument;
          this.dossier = data.assetInfo.commercialDossierDocument;
          this.legal = data.assetInfo.legalInformationDocument;
          this.transmitter = data.assetInfo.transmitterDocument;
          this.project = data.assetInfo.projectDocument;
        })
        .catch(err => {
          this.message.msg = err.response.data.message;
          this.message.type = 'alert-warning';
          this.message.state = true;
          this.scrollNavigator();
        });
    },
    loadJSONCountries() {
      // load the list of countries for the selection of the country of the asset
      this.countries = require('../account/countries.json');
      for (let i = 0; i < this.countries.length; i++) {
        this.country_list.push(this.countries[i].name);
      }
    },
    changeTabAndNextStep() {
      // wait 2 seconds to change the panel and move the step-bar
      setTimeout(() => {
        this.$emit('update', 2);
        move_tabs.moveTab();
      }, 2000);
    },
    scrollNavigator() {
      // scroll to the top of the browser
      // so that the user can view the alert
      window.scroll({
        top: -5000,
        behavior: 'smooth',
      });
    },
    downloadMetamask() {
      const onboarding = new MetaMaskOnboarding();
      onboarding.startOnboarding();
    },
  },
};
</script>
